import { PrimaryInput } from '@attom';
import { useRef, useState } from 'react';

import CS from './PrimarySelect.module.scss';

export const PrimarySelect = ({
	// box control
	boxClass = '',
	boxSpace = '',
	boxSize = '',
	// element control
	elClass = '',
	elSpace = 'py-8px px-20px',
	color = 'base', // colorsList in (framework && styles)
	//
	options = [],
	selectedItem = '',
	label = '',
	placeholder = '',
	required = null,
	showImage = null,
	notDatalist = null,
	//
	nameProperty = 'NAME',
	valueProperty = 'ID',
	imageProperty = 'img',
	emptyOption = 'موردی یافت نشد',
	successStatus = null,
	//
	onChange = null,
	disabled = null,
	readOnly = null,
	...props
}) => {
	const [search, setSearch] = useState((selectedItem && selectedItem[nameProperty]) || '');
	const [collapse, setCollapse] = useState(true);

	const ref = useRef();

	const changeInput = (e) => {
		if (onChange) onChange(null);
		setSearch(e.target.value);
	};

	const selectItem = (item) => {
		setSearch(item[nameProperty]);
		setCollapse(true);
		onChange && onChange(item);
	};

	const onFocusHandler = (e) => {
		setCollapse(false);
		setSearch('');
	};

	const onBlurHandler = (e) => {
		if (!collapse)
			setTimeout(() => {
				setCollapse(true);
			}, 250);
	};

	const searchedName = (selectedItem && selectedItem[nameProperty]) || search;
	const filteredOptions = [...options.filter((item) => !search || item[nameProperty].includes(searchedName))];

	return (
		<PrimaryInput
			boxClass={`${boxClass} ${CS.container}`}
			boxSize={boxSize}
			boxSpace={boxSpace}
			elClass={`${elClass} ${CS.input}`}
			elSpace={elSpace}
			placeholder={placeholder}
			label={label}
			value={searchedName}
			isValid={
				!successStatus && selectedItem && selectedItem[valueProperty]
					? null
					: Boolean(selectedItem && selectedItem[valueProperty])
			}
			onChange={changeInput}
			onBlur={onBlurHandler}
			onFocus={onFocusHandler}
			readOnly={notDatalist}
			required={required}
			{...props}
		>
			{!collapse && (
				<div className={CS.options} ref={ref}>
					{filteredOptions.map((item, i) => (
						<div key={i} className={CS.option} onClick={() => selectItem(item)}>
							{showImage && item[imageProperty] && <img alt='icon' src={item[imageProperty]} className={CS.image} />}
							{item[nameProperty] && <span className={CS.name}>{item[nameProperty]}</span>}
						</div>
					))}
					{filteredOptions.length === 0 && <div className={CS.empty}>{emptyOption}</div>}
				</div>
			)}
		</PrimaryInput>
	);
};
